<template>
    <div class="modal-window bds038">
        <header class="modal-header">
            <div class="tit">날짜별 엑셀 다운로드</div>
            <button @click="closePopup" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">

            <div class="tag_sel_wrap">
                <div class="tag_sel">
                    
                    <span
                        v-for="(item,index) in modalInfo.item" :key="index"
                    >
                        <input type="checkbox" :id="'tag_' + index" :value="item" v-model="selectedTags" @change="addTags"><label :for="'tag_' + index">{{ item.codeDesc }}</label>
                    </span>
                </div>
            </div>

            <div class="member_grp tag">
                <div class="scroll">
                    <p class="nodata" v-if="nodataYn"><span>다운로드 받을 컬럼을 선택해 주세요.</span></p>
                    <div v-for="(item, index) in selectedTags" :key="'selectedTag_'+index">#{{item.codeDesc}} <button type="button" @click="removeTag(item)">x</button></div>
                </div>
            </div>

        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="getExcelDownload('userStatForDate', null)">엑셀 다운로드</button>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
    props:{
        modalInfo: {
      type: Object,
      required: true,
    }
    },
    components: {},
    data() {
        return { 
            nodataYn: true,
            tagItems: [],
            jobGroups : [],

            selectedJobGroup : null, // 선택된 컬럼
            selectedJobGroupYn : true,
            selectedTags: [], // 선택된 컬럼 목록

            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            }, 
        };
    },



methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showModal","showToast"]),
      
        /* 선택된 컬럼 지우기. */
        removeTag(item){
            let obj = this;
            this.selectedTags.forEach(function(tag, idx){
                if(tag.codeDesc === item.codeDesc){
                    obj.selectedTags.splice(idx,1);
                    return false;
                } 
            })

            if(this.selectedTags.length == 0 ){
                this.nodataYn = true;
            }
        },

        /* 태그 선택 */
        addTags(){
            this.nodataYn = false;
        },
        
        getExcelDownload(type, item) {
        if(this.selectedTags.length < 1){
                this.showAlertDialog("한개 이상 선택해야 합니다.", null, {
                    width: "400px",
                });
        }else{
        this.showLoadingbar(); // 프로그레스바 시작
        let fileName = "사용자_날짜별_활동현황";
      
        let param = {
            downloadType: type,
            startDate: this.$moment(this.modalInfo.startDate).format("YYYY-MM-DD"),
            endDate: this.$moment(this.modalInfo.endDate).format("YYYY-MM-DD"),
            statDay: null,
            sortDesc: false, // this.sortDesc,
            sortBy: "USER_NAME", // this.sortBy,
            fileName: fileName,
            searchKeyword: this.modalInfo.searchKeyword,
            page: 0,
            perSize: null,
            headers: this.modalInfo.headers,
            columnsInfo: this.selectedTags
      }

        this.$axios({
            url : "/api/monitor/stat/downloadExcel",
            responseType: "blob",
            headers: {
                "Content-Type": "application/json"
            },
            method : "post",
            data: param
        }).then(res => {
        let blob = new Blob([res.data], {
          type: res.headers["content-type"]
        });
      
        fileName += "("+this.$moment(this.modalInfo.startDate).format("YYYY.MM.DD") + "_" + this.$moment(this.modalInfo.endDate).format("YYYY.MM.DD")+")";

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName+".xlsx");
        } else {
          let link = document.createElement("a");
          link.target = "_self";
          link.setAttribute("download", fileName+".xlsx");
          link.href = window.URL.createObjectURL(blob);
          link.click();
          link.remove();
        }

        this.hideLoadingbar(); //프로그레스바 종료
      })
      .catch(function(err) {
        console.log(err);
        this.hideLoadingbar(); //프로그레스바 종료
      });
        }
        
    },
        closePopup() {
            let body = document.querySelector("body");
            body.style.removeProperty("overflow");
            this.$emit("close");
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/ExcelFilter.vue